<template>
  <div class="ml-6 mr-6"> <!--note: mt,mb,ml,mr(margin) jangan diubah-->
  <v-breadcrumbs :items="page" class="pa-0 ma-0 mt-0 pt-0 "></v-breadcrumbs>
    <v-layout row wrap class="mt-4">
      <v-flex sm12 xs12 md12 lg12>
        <v-card height="auto" class="mb-6 rounded-lg" flat>
          <v-card-title height="50" class="body-2 font-weight-regular blue-grey lighten-5 grey--text">
            <v-icon small class="mr-4" color="grey">mdi-laptop</v-icon> List Role Privileges
          </v-card-title>
          <div class="pa-6">
          <v-row>
            <v-col cols="12" sm="2">
              <v-select outlined 
              v-model="role_id_model" 
              :items="rolename"
              item-text="name_role" 
              item-value="value_role" 
               label="Role Name" dense></v-select>
            </v-col>
            <v-col cols="12" sm="2">
              <v-select outlined 
              v-model="status_model" 
              :items="privstatus" 
              item-text="name_status" 
              item-value="value_status" 
              label="Priv Status" dense></v-select>
            </v-col>
          </v-row>
          <v-card outlined style="width: 500px;">
            <v-simple-table class="overflow-card pa-0 ma-0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">SELECT</th>
                    <th class="text-left">TOPIC</th>
                  </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) of keywordPrivilages" :key="item.SEQ_ID">
                  <td>
                    <v-checkbox 
                    v-model="selected[index]"
                    value="Disabled"
                    false-value="0"
                    true-value="1"
                    small dense class="py-0 my-0" color="primary" hide-details >
                    </v-checkbox>
                  </td>
                  <td>{{item.GROUP_NAME}} </td>
                </tr>
                <!-- <tr>
                  <td><v-checkbox small dense class="py-0 my-0" color="primary" hide-details></v-checkbox></td>
                  <td>Joko Widodo</td>
                </tr>
                <tr>
                  <td><v-checkbox small dense class="py-0 my-0" color="primary" hide-details></v-checkbox></td>
                  <td>Natuna</td>
                </tr>
                <tr>
                  <td><v-checkbox small dense class="py-0 my-0" color="primary" hide-details></v-checkbox></td>
                  <td>Corona</td>
                </tr>
                <tr>
                  <td><v-checkbox small dense class="py-0 my-0" color="primary" hide-details></v-checkbox></td>
                  <td>Pertamina</td>
                </tr>
                <tr>
                  <td><v-checkbox small dense class="py-0 my-0" color="primary" hide-details></v-checkbox></td>
                  <td>Taspen</td>
                </tr> -->
              </tbody>
            </template>
          </v-simple-table>
        </v-card>
        </div>
        <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mx-3 px-4" color="primary" rounded dark  @click="save">
              save<v-icon class="ml-2">mdi-content-save-outline</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
        <Notification  ref="alert"></Notification>
  </div>
</template>

<script>
import axios from "axios"
import Notification from  '@/components/Notification';
export default {
    components: {
      Notification: Notification
    },
  data:() => ({
    // return {
      selected:[],
      keywordPrivilages:[],
      role_id_model:'',
      rolename: [
          {
            value_role: '', 
            name_role: ''
          }
      ],
      // privstatus: ['Enabled', 'Disabled'],
      status_model: 1,
      privstatus: [
          {
            value_status: 1, 
            name_status: 'Enabled'
          },
          {
            value_status: 0, 
            name_status: 'Disabled'
          },
      ],
      page: [
        {
          text: 'Home',
          disabled: false,
          href: 'breadcrumbs_dashboard',
        },
        {
          text: 'Keyword Manager',
          disabled: false,
          href: 'breadcrumbs_link_1',
        },
        {
          text: 'Keyword Role Privileges',
          disabled: true,
          href: 'breadcrumbs_link_2',
        },
      ],
    // }
  }),
  
  created () {
      this.initialize()
    },
    methods: {
      async initialize () {
        axios.get("/keyword-role-privelages",
          { headers:{'auth-token':localStorage.getItem('token_app')}},
          {dataType: 'json'}
          ).then((response) => {
            this.keywordPrivilages = response.data.group_keyword;
       
            this.keywordPrivilages.forEach((value, index) => {
              // alert(value.CHECKED);
              // v-bind:value="`${item.SEQ_ID}`"
                this.selected[index] = value.SEQ_ID;
                console.log(value.CHECKED);
                console.log(index);
            });


            const role = response.data.role_keyword;
            // console.log(this.keywordPrivilages);
            // ROLE_STATUS
            let result = '';
            let arr_data = [];
            if(role.length > 0){
              for (let i = 0; i < role.length; i++) {  
                  if(i == 0){
                    this.role_id_model = (role[i].SEQ_ID);
                    this.status_model = (role[i].ROLE_STATUS);
                  }
                  result = {
                    value_role :role[i].SEQ_ID,
                    name_role :role[i].ROLE_NAME
                  };
                  arr_data.push(result);
              }
              // console.log(arr_data);
              this.rolename= arr_data;
            }
            
            // end loading 
            setTimeout(() =>{
              this.loading = false
            },1000)
          })
          .catch((e) => {
              switch (e.response.status) {
                    case 404:
                          this.$refs.alert.error_login(404);
                        break;
                    case 403:
                          this.$refs.alert.error_login(403);
                        break;
                    default:
                        console.log('some other error');  // end up here all the time
                        break;
                  }
          this.errors=e.response.data.msg;
        });
      },

      save () {
        this.role_id_model
        this.role_id_model
        console.log(this.selected);

        // if (this.editedIndex > -1) {
        //   Object.assign(this.restapi[this.editedIndex], this.inputItem)
        // }else{
        //   Object.assign(this.restapi[this.editedIndex], this.inputItem)
        // }

      }





    }
}
</script>

<style scoped> 
/*note css jangan diubah*/
.v-sheet--offset {
  top: -24px;
  position: relative;
}
#app{
  background-color: #F4F7FA;
}
.apexcharts-toolbar {
  z-index: 0;
}
.tooltip .tooltip-inner{
  max-width: 100px !important;
  width: 100px !important;
}
.v-tooltip__content {
  font-size: 13px !important;
  max-width: 100px;
}
.row-pointer{
  cursor: grab;
}
svg {
  display: block;
  margin: 0 auto;
}
.chart {
  transition: transform 0.7s ease-in-out;
  text-anchor: middle;
  cursor: pointer;
}
.chart__circle {
  transition: r .3s ease-in-out;
}
.chart__label {
  fill: #fff;
  font-weight: bold;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}
.v-select.label{
  color: #fff;
}

</style>
